import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LoginUser } from '../models/login-user';
import { ApiResponse } from '../models/api-response';
import { UserMenuNodes } from '../models/user-menu-nodes';
import { ComponentsType } from '../models/component-data';

import { AppConfigService } from '../app-config.service.service';
import { ToastService } from 'ng-uikit-pro-standard';

import { BehaviorSubject, from, Observable } from 'rxjs';
import { templateJitUrl } from '@angular/compiler';

import { HttpHeaders } from '@angular/common/http';


// import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class DasboardService {
  private uri = "";// `${environment.apiUrl}`;
  private moduleId;
  private baseurlUtility = "";

  constructor(
    private http: HttpClient, 
    private appConfigService: AppConfigService,
    private toastService: ToastService, private appSetting: AppConfigService) {
    this.uri = this.appConfigService.apiBaseUrl;
    this.baseurlUtility = this.appSetting.apiBaseUrlUtility;

   }

   getDashboard(fromtemplate: boolean) {

    // const currentUrl = this.router.url;

    this.uri = this.appConfigService.apiBaseUrl;
    this.baseurlUtility = this.appSetting.apiBaseUrlUtility;

    // this.uri = currentUrl.includes('biAdminComponent') ? 
    // this.appConfigService.apiBaseUrlUtility + '/FlexIntegration/Dashboard': ;    

    const executeAll = sessionStorage.getItem('executeAll');
    const curDashboardID = sessionStorage.getItem('curDashboardID');

    console.log(executeAll);
    console.log(curDashboardID);
  

  
    if (executeAll === '1') {
      this.moduleId = '-1';
    } else {
      this.moduleId = sessionStorage.getItem('moduleId') || '0'; 
    }
  
    const body: any = {
      moduleid: this.moduleId
    };
  
    if (curDashboardID !== null) {
      body.dashboardid = curDashboardID;
    }

    sessionStorage.setItem('executeAll', '0');
    sessionStorage.removeItem('curDashboardID');

    if (fromtemplate == true){
      console.log('La api');
      console.log(this.baseurlUtility);
      body.method = 'Get_UserDashBoardsAdmin';
      return this.http.post<any>(this.baseurlUtility + '/FlexIntegration/Dashboard', body);
    }
    else{
      body.method = 'Get_UserDashBoardsV2';
      return this.http.post<any>(this.uri + '/FlexIntegration', body);
    }

  }

  getDashboardById(id, fromtemplate: boolean = false) {
    this.uri = this.appConfigService.apiBaseUrl;
    this.baseurlUtility = this.appConfigService.apiBaseUrlUtility;


   if (fromtemplate == true){
    return this.http.post<ComponentsType[]>(this.baseurlUtility + '/DashboardComponents/Template', {DashboardID: id});
   }
   else{
    return this.http.post<ComponentsType[]>(this.uri + '/DashboardComponents', {DashboardID: id});
   }

  }

  getDashboardByIdCubeBox(params) {
    console.log(params)
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<ComponentsType[]>(this.uri + '/DashboardComponents', params );
  }

  getUsers() {
    this.uri = this.appConfigService.apiBaseUrl;

    return this.http.post<any>(this.uri + '/FlexIntegration',{ method: 'Get_AllUser' });

  }

  Get_CompanyMetricInfoByMetricID(obj: any) {
    this.uri = this.appConfigService.apiBaseUrl;

    return this.http.post<any>(this.uri + '/FlexIntegration', obj );

  }  

  shareDashboard(obj: any) {
    this.uri = this.appConfigService.apiBaseUrl;

    return this.http.post<any>(this.uri + '/FlexIntegration', obj );

  }

  getData(componentId, fromtemplate: boolean) {
    // return this.http.post<any>(this.uri + endpoint, {});
    
    this.uri = this.appConfigService.apiBaseUrl;
    this.baseurlUtility = this.appSetting.apiBaseUrlUtility;

    if (fromtemplate == true){
      return this.http.post(this.baseurlUtility + '/DashboardsComponentsData/GetDataFromTemplate', {ComponentID: componentId});
    }
    else{
      return this.http.post(this.uri +  '/DashboardsComponentsData/GetData', {ComponentID: componentId});
    }

  }

  getRefreshComponentData(componentsId) {
    // return this.http.post<any>(this.uri + endpoint, {});
    
    this.uri = this.appConfigService.apiBaseUrl;
    this.baseurlUtility = this.appSetting.apiBaseUrlUtility;

    return this.http.post<any>(this.uri + '/FlexIntegration',{ method: 'getRefreshComponentData', componentsId: componentsId });

  }

  deleteDashboard(id, fromtemplate: boolean = false) {
    
    this.uri = this.appConfigService.apiBaseUrl;
    this.baseurlUtility = this.appSetting.apiBaseUrlUtility;

    if (fromtemplate == false){
      
      // return this.http.post<any>(this.uri + '/Dashboard/Delete_Dashboard', {id: id});
      return this.http.post<any>(this.uri + '/FlexIntegration',{ method: 'Get_DeleteUserDashBoards', dashboardid: id });
    }
    else{
      return this.http.post<any>(this.baseurlUtility + '/Dashboard/Delete_DashboardTemplate', {id: id});

    }


  }

  updateDashboard(item, fromtemplate: boolean = false) {
    
    this.uri = this.appConfigService.apiBaseUrl;
    this.baseurlUtility = this.appSetting.apiBaseUrlUtility;

    this.moduleId = sessionStorage.getItem('moduleId');
    item.moduleid = this.moduleId;
    if (fromtemplate == false){
      return this.http.post<any>(this.uri + '/Dashboard/Update_Dashboard', item);
    }
    else{
      return this.http.post<any>(this.baseurlUtility + '/Dashboard/Update_DashboardTemplate', item);
    }
  }

  newDashboard(newDashboard, fromtemplate: boolean = false) {

    this.uri = this.appConfigService.apiBaseUrl;
    this.baseurlUtility = this.appSetting.apiBaseUrlUtility;


    this.moduleId = sessionStorage.getItem('moduleId');
    newDashboard.moduleid = this.moduleId;
    // console.log(newDashboard);
    // return;
    
    if (fromtemplate == false){
      return this.http.post<any>(this.uri + '/Dashboard/InsertDashboard', newDashboard);
    }
    else{
      return this.http.post<any>(this.baseurlUtility + '/Dashboard/InsertDashboardTemplate', newDashboard);
    }

  }

  GetALlDashboardComponents() {
    this.uri = this.appConfigService.apiBaseUrl;
    this.moduleId = sessionStorage.getItem('moduleId');
    if (!this.moduleId) {
      this.toastService.info('The module is not defined');
    }
    return this.http.post<any>(this.uri + '/DashboardComponents/GetALlDashboardComponents', {
      moduleid: this.moduleId
    });
  }

  GetALlDashboardComponentsFlex(fromtemplate: boolean = false) {
    this.uri = this.appConfigService.apiBaseUrl;
    this.moduleId = sessionStorage.getItem('moduleId');
    if (!this.moduleId) {
      this.toastService.info('The module is not defined');
    }    
    if (fromtemplate == true){
      return this.http.post<any>(this.uri + '/FlexIntegration',{ method: 'Get_AllDashboardComponentsV2', moduleid: this.moduleId });
    }
    else{
      return this.http.post<any>(this.uri + '/FlexIntegration',{ method: 'Get_AllDashboardComponentsV2Client', moduleid: this.moduleId });
    }
  }

  addNewComponentDashboard(model, fromtemplate: boolean = false) {
    
    this.uri = this.appConfigService.apiBaseUrl;
    this.baseurlUtility = this.appSetting.apiBaseUrlUtility;

    if (fromtemplate == true){
      return this.http.post<any>(this.baseurlUtility + '/DashboardComponents/InsertDashboardComponentsTemplate', model);
    }
    else{
      return this.http.post<any>(this.uri + '/DashboardComponents/InsertDashboardComponents', model);
    }

  }

  UpdateDashBoardComponents(dashboardid, list, fromtemplate: boolean = false) {
    
    this.uri = this.appConfigService.apiBaseUrl;
    this.baseurlUtility = this.appSetting.apiBaseUrlUtility;

    if (fromtemplate == true){
      return this.http.post(this.baseurlUtility + '/DashboardComponents/UpdateDashBoardComponentsTemplate', {DashboardID: dashboardid, Components: list});
    }
    else{
      return this.http.post(this.uri + '/DashboardComponents/UpdateDashBoardComponents', {DashboardID: dashboardid, Components: list});
    }


  }

  UpdateDashBoardComponentsGridster(dashboardid, list, dashboardoptionjson, fromtemplate: boolean = false) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration',{ method: 'UpdateDashBoardComponentsGridster', dashboardid: dashboardid, listjson: list, dashboardoptionjson: dashboardoptionjson, fromtemplate: fromtemplate });
  }

  GetDashBoardComponentsGridster(dashboardid, fromtemplate: boolean = false) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration',{ method: 'GetDashBoardComponentsGridster', dashboardid: dashboardid, fromtemplate: fromtemplate });
  }

  // admin component
  GetDashboardComponentsConf(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/DashboardComponents/GetDashboardComponentsConf', model);
  }

  GetDashboardComponentsConfDataSources() {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/DashboardComponents/GetDashboardComponentsConfDataSources', {});
  }

  GetMasterDashboardComponentsConfDataSources() {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration', {method: 'Get_MasterDashboardComponentsDataSources'});
  }

  GetMasterDashboardKPIs() {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration', {method: 'Get_CompanyMetricsForDashboard'});
  }

  SaveDashboardModules(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration', model);
  }

  UpdateDashboardAvaliable(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    model.method = "UpdateDashboardAvaliable"
    console.log(model);
    return this.http.post<any>(this.uri + '/FlexIntegration', model);
  }

  ModifiAvaliableComponent(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    model.method = "ModifiAvaliableComponent"
    console.log(model);
    return this.http.post<any>(this.uri + '/FlexIntegration', model);
  }

  ModifiActiveComponent(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    model.method = "ModifiActiveComponent"
    console.log(model);
    return this.http.post<any>(this.uri + '/FlexIntegration', model);
  }

  SaveDashboardImage(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post(this.uri + '/DownloadFile/Upload', model)
  }

  GetDashboardImage(filepath): Observable<any> {
    return this.http.post(this.uri + '/DownloadFile/Download', { filename: filepath });
  }  

  GetDashboardComponentImage(filepath: string): Observable<any> {
    const headers = new HttpHeaders().set('X-Skip-Loading', 'true');
    return this.http.post(this.uri + '/DownloadFile/Download', { filename: filepath }, { headers });
  }

  DeleteDashboard(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    model.method = 'DeleteDashboard';
    return this.http.post<any>(this.uri + '/FlexIntegration', model);
  }

  DeleteDashboardTemplate(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    model.method = 'DeleteDashboardTemplate';
    return this.http.post<any>(this.uri + '/FlexIntegration', model);
  }

  Get_AllMasterDashboards(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    model.method = 'Get_AllMasterDashboards';
    return this.http.post<any>(this.uri + '/FlexIntegration', model);
  }

  ImportDashboard(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    model.method = 'ImportDashboard';
    return this.http.post<any>(this.uri + '/FlexIntegration', model);
  }

  UpdateComponentsConfDataSources(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/DashboardComponents/UpdateComponentsConfDataSources', model);
    // tslint:disable-next-line: max-line-length
    // {ComponentId: 0, Name: 'ComponentName', Description: 'ComponentDescription', ComponentTypeId: 9, DataSource: 'ComponentDataSourceTEXT'}
  }

  Get_ClientDashboards(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration', model);
  }

  Get_MasterDashboardComponents() {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "Get_MasterDashboardComponents" });
  }  

  Get_MasterDashboardComponentsClient() {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "Get_MasterDashboardComponentsClient" });
  }  

  UpdateMasterComponents(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    model.method = 'InsertUpdate_DashboardComponents';
    return this.http.post<any>(this.uri + '/FlexIntegration', model);
  }

  DeleteComponent(model) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/FlexIntegration', model);
  }

  DeleteComponentsConfDataSources(id) {
    this.uri = this.appConfigService.apiBaseUrl;
    return this.http.post<any>(this.uri + '/DashboardComponents/DeleteComponentsConfDataSources', {ComponentId: id});
  }

  GetDashboardComponentsModules() {
    return this.http.post<any>(this.uri + '/DashboardComponents/GetDashboardComponentsModules', {});
  }

  GetDashboardComponentsUserGroup() {
    return this.http.post<any>(this.uri + '/DashboardComponents/GetDashboardComponentsUserGroup', {});
  }

  GetDashboardComponentsConfModulesUserGroups(componentid) {
    return this.http.post<any>(this.uri + '/DashboardComponents/GetDashboardComponentsConfModulesUserGroups', {ComponentId: componentid});
  }
}
